import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import PropTypes from 'prop-types';

const PartsList = ({ parts }) => {
    return (
        <div
            className={'text-center my-4 mt-5'}>
            <h3
                className={'fw-bold border-top py-2 mb-4'}>All Industrial Machines and Parts are Available</h3>
            <Row
                className={'g-4 justify-content-center'}>
                {parts.map((item) => (
                    <Col
                        xs={6}
                        sm={4}
                        md={3}
                        lg={2}
                        key={item.label}
                        className={'text-dark d-flex flex-column align-items-center'}>
                        {!item.url && (<>
                            {item.image && (
                                <Image
                                    src={item.image}
                                    alt={item.label}
                                    fluid
                                    style={{ maxHeight: '90px',
                                        objectFit: 'contain' }} />
                            )}
                            <span
                                className={'mt-2'}>{item.label}</span></>)}
                        {item.url && (
                            <a
                                href={item.url}
                                target={'_blank'}
                                rel={'noopener noreferrer'}
                                className={'text-decoration-none text-dark d-flex flex-column align-items-center'}>
                                {item.image && (
                                    <Image
                                        src={item.image}
                                        alt={item.label}
                                        fluid
                                        style={{ maxHeight: '90px',
                                            objectFit: 'contain' }} />
                                )}
                                <span
                                    className={'mt-2'}>{item.label}</span>
                            </a>
                        )}
                    </Col>
                ))}
            </Row>
        </div>
    );
};

PartsList.propTypes = {
    parts: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired
        })
    ).isRequired
};

export default PartsList;
